export default "__VITE_ASSET__Cw0Z8qF5__"